import React, { Component } from 'react';
import axios from 'axios';
import NumberFormat from 'react-number-format';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Icon, Card, Divider } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import userProfileImageHolder from '../user_profile.jpg';
import moment from 'moment';
import Image from 'react-image-resizer';

import { useMediaQuery } from 'react-responsive'

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 992 })
  return isDesktop ? children : null
}
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
  return isTablet ? children : null
}
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}

const API_HOST_URL = process.env.REACT_APP_API_URL


const style = {
    profileImage: {
        display: 'inline',
        margin: '0 auto',
        // marginLeft: '-25%',
        height: '100%',
        width: 'auto'
    },
    vehicleImage: {
        display: 'inline',
        margin: '0 auto',
        height: '100%',
        width: 'auto',
        borderRadius: '5%'
    },
};

class TripDetail extends Component {
    state = {
        trip: {}
    }

    componentDidMount() {
        const tripId = this.props.match.params.tripId;
        console.log("TripId: ", tripId);
        axios.get(`${API_HOST_URL}/api/trips/${tripId}/?expand=user`)
            .then(res => {
                this.setState({
                    trip: res.data
                })

                console.log("trip data: ", res.data);
            })
    }

    render() {
        const { trip } = this.state;

        return (
            <div>
                <Desktop>
                <Card>
                    <Row>
                        <Col md={{ span: 4, offset: 3 }}>
                            {/* <img src={userProfile} style={{height: '60%', width: '60%'}} alt="logo" /> */}
                            <Link to={`/user-profile/${trip.user && trip.user.id}`}>
                                <div className="image-cropper">
                                    <Image
                                        src={(trip.user && trip.user.profilePhoto !== null) ? (trip.user && trip.user.profile.profilePhoto) : userProfileImageHolder}
                                        height={100}
                                        width={100}
                                        style={style.profileImage}
                                    />
                                </div>
                            </Link>
                            <h3 style={{ fontWeight: "bold" }} className="GrayText">{(trip.user && trip.user.first_name) + ' ' + (trip.user && trip.user.last_name)}</h3>
                            {/* <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                        <Icon type="star" theme="filled" />5.0 &nbsp;
                        <span style={{fontWeight: "normal", color: '#0099ff'}}>5 Reviews</span>
                        </h4> */}

                        </Col>
                        <Col md={{ span: 8 }}>
                            <h1 style={{ color: '#0099ff' }}>
                                {trip.originCity} to {trip.destinationCity}
                            </h1>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">Leaving</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">
                                        {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "HH:mm").format("hh:mm A")}
                                    </h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText"><span id="icon_from"></span>Pickup</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.originCity}</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">Dropoff</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.destinationCity}</h3>
                                </Col>
                            </Row>
                            {/* <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">Distance</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">200km (5h travel time)</h3>
                            </Col>
                        </Row> */}
                            <Row>
                                <Col md={{ span: 22 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                        {trip.tripDescription}
                                    </h3>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 6 }}>
                            <Card>
                                <Row>
                                    <Col md={{ span: 16 }}>
                                        {/* <img src={carImage} style={{height: '90%', width: '90%'}} alt="logo" /> */}
                                        <Image
                                            src={(trip.user && trip.user.primary_vehicle.length > 0) && (API_HOST_URL + (trip.user && trip.user.primary_vehicle[0].vehiclePhoto))}
                                            height={100}
                                            width={150}
                                        // style={style.vehicleImage}
                                        />
                                    </Col>
                                    <Col md={{ span: 8 }}>
                                        <h4 style={{ fontWeight: "bold" }} className="GrayText"> {trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate}</h4>
                                        <h4 className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel}</h4>
                                        <h4 style={{ fontWeight: "normal" }} className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].color}</h4>
                                    </Col>
                                </Row>
                                <Divider />

                                <h4 style={{ fontWeight: "normal" }} className="GrayText">
                                    <Icon type="shopping" theme="filled" style={{ color: `${(trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed == 'No') ? 'red' : 'green'}` }} /> {trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed} Luggage allowed</h4>

                            </Card>
                        </Col>
                    </Row>
                </Card>
                {/* #0099ff */}
                <Row style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                    <Col md={{ span: 4, offset: 3 }} >
                        {trip.numberOfSeats > 0 &&
                            <Card bordered={false} style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                                <h3 style={{ color: "#ffffff" }}>Booked: {trip.numberOfSeatsBooked}</h3>
                            </Card>
                        }
                    </Col>
                    <Col md={{ span: 8 }} >
                        <Card bordered={false} style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                            {trip.numberOfSeats > 0 ?
                                <Button size="large" type="primary" style={{ backgroundColor: "#ff3d00", borderWidth: '0px' }}>
                                    <Link to={`book/${trip.id}`}>Book Seats Now</Link>
                                </Button>
                                :
                                <h2 style={{ color: 'white' }}>Trip fully booked</h2>
                            }
                        </Card>
                    </Col>
                    <Col md={{ span: 6 }}>
                        <Card bordered={false} style={{ backgroundColor: "#1275b5" }}>
                            <Row>
                                <Col md={{ span: 8 }}>
                                    <h3 style={{ color: "#ffffff" }}>
                                        {
                                            trip.numberOfSeats > 0 &&
                                            <div>
                                                <span style={{ fontSize: '1.5em' }}>{trip.numberOfSeats}</span>
                                                <span>{ trip.numberOfSeats > 1 ? 'seats':'seat'} left</span>
                                            </div>
                                        }
                                    </h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ color: "#ffffff" }}>
                                        <span style={{ fontSize: '1.5em' }}>
                                            <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                        </span>
                                        <span> <br />per seat</span>
                                    </h3>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                </Desktop>
                
                <Tablet>
                <Card>
                    <Row>
                        <Col md={{ span: 4, offset: 3 }}>
                            {/* <img src={userProfile} style={{height: '60%', width: '60%'}} alt="logo" /> */}
                            <Link to={`/user-profile/${trip.user && trip.user.id}`}>
                                <div className="image-cropper">
                                    <Image
                                        src={(trip.user && trip.user.profilePhoto !== null) ? (trip.user && trip.user.profile.profilePhoto) : userProfileImageHolder}
                                        height={100}
                                        width={100}
                                        style={style.profileImage}
                                    />
                                </div>
                            </Link>
                            <h3 style={{ fontWeight: "bold" }} className="GrayText">{(trip.user && trip.user.first_name) + ' ' + (trip.user && trip.user.last_name)}</h3>
                            {/* <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                        <Icon type="star" theme="filled" />5.0 &nbsp;
                        <span style={{fontWeight: "normal", color: '#0099ff'}}>5 Reviews</span>
                        </h4> */}

                        </Col>
                        <Col md={{ span: 8 }}>
                            <h1 style={{ color: '#0099ff' }}>
                                {trip.originCity} to {trip.destinationCity}
                            </h1>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">Leaving</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">
                                        {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "HH:mm").format("hh:mm A")}
                                    </h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText"><span id="icon_from"></span>Pickup</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.originCity}</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">Dropoff</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.destinationCity}</h3>
                                </Col>
                            </Row>
                            {/* <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">Distance</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">200km (5h travel time)</h3>
                            </Col>
                        </Row> */}
                            <Row>
                                <Col md={{ span: 22 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                        {trip.tripDescription}
                                    </h3>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 6 }}>
                            <Card>
                                <Row>
                                    <Col md={{ span: 16 }}>
                                        {/* <img src={carImage} style={{height: '90%', width: '90%'}} alt="logo" /> */}
                                        <Image
                                            src={(trip.user && trip.user.primary_vehicle.length > 0) && (API_HOST_URL + (trip.user && trip.user.primary_vehicle[0].vehiclePhoto))}
                                            height={100}
                                            width={150}
                                        // style={style.vehicleImage}
                                        />
                                    </Col>
                                    <Col md={{ span: 8 }}>
                                        <h4 style={{ fontWeight: "bold" }} className="GrayText"> {trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate}</h4>
                                        <h4 className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel}</h4>
                                        <h4 style={{ fontWeight: "normal" }} className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].color}</h4>
                                    </Col>
                                </Row>
                                <Divider />

                                <h4 style={{ fontWeight: "normal" }} className="GrayText">
                                    <Icon type="shopping" theme="filled" style={{ color: `${(trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed == 'No') ? 'red' : 'green'}` }} /> {trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed} Luggage allowed</h4>

                            </Card>
                        </Col>
                    </Row>
                </Card>
                {/* #0099ff */}
                <Row style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                    <Col md={{ span: 4, offset: 3 }} >
                        {trip.numberOfSeats > 0 &&
                            <Card bordered={false} style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                                <h3 style={{ color: "#ffffff" }}>Booked: {trip.numberOfSeatsBooked}</h3>
                            </Card>
                        }
                    </Col>
                    <Col md={{ span: 8 }} >
                        <Card bordered={false} style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                            {trip.numberOfSeats > 0 ?
                                <Button size="large" type="primary" style={{ backgroundColor: "#ff3d00", borderWidth: '0px' }}>
                                    <Link to={`book/${trip.id}`}>Book Seats Now</Link>
                                </Button>
                                :
                                <h2 style={{ color: 'white' }}>Trip fully booked</h2>
                            }
                        </Card>
                    </Col>
                    <Col md={{ span: 6 }}>
                        <Card bordered={false} style={{ backgroundColor: "#1275b5" }}>
                            <Row>
                                <Col md={{ span: 8 }}>
                                    <h3 style={{ color: "#ffffff" }}>
                                        {
                                            trip.numberOfSeats > 0 &&
                                            <div>
                                                <span style={{ fontSize: '1.5em' }}>{trip.numberOfSeats}</span>
                                                <span>{ trip.numberOfSeats > 1 ? 'seats':'seat'} left</span>
                                            </div>
                                        }
                                    </h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ color: "#ffffff" }}>
                                        <span style={{ fontSize: '1.5em' }}>
                                            <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                        </span>
                                        <span> <br />per seat</span>
                                    </h3>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                </Tablet>

                <Mobile>
                <Card>
                    <Row>
                        <Col md={{ span: 4, offset: 3 }}>
                            {/* <img src={userProfile} style={{height: '60%', width: '60%'}} alt="logo" /> */}
                            <Link to={`/user-profile/${trip.user && trip.user.id}`}>
                                <div className="image-cropper">
                                    <Image
                                        src={(trip.user && trip.user.profilePhoto !== null) ? (trip.user && trip.user.profile.profilePhoto) : userProfileImageHolder}
                                        height={100}
                                        width={100}
                                        style={style.profileImage}
                                    />
                                </div>
                            </Link>
                            <h3 style={{ fontWeight: "bold" }} className="GrayText">{(trip.user && trip.user.first_name) + ' ' + (trip.user && trip.user.last_name)}</h3>
                            {/* <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                        <Icon type="star" theme="filled" />5.0 &nbsp;
                        <span style={{fontWeight: "normal", color: '#0099ff'}}>5 Reviews</span>
                        </h4> */}

                        </Col>
                        <Col md={{ span: 8 }}>
                            <h1 style={{ color: '#0099ff' }}>
                                {trip.originCity} to {trip.destinationCity}
                            </h1>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">Leaving</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">
                                        {moment(trip.departureDate).format('dddd, D MMMM YYYY')} at {moment(trip.departureTime, "HH:mm").format("hh:mm A")}
                                    </h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText"><span id="icon_from"></span>Pickup</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.originCity}</h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={{ span: 6 }}>
                                    <h3 style={{ fontWeight: "bold" }} className="GrayText">Dropoff</h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">{trip.destinationCity}</h3>
                                </Col>
                            </Row>
                            {/* <Row>
                            <Col md={{span: 6}}>
                                <h3 style={{fontWeight: "bold"}} className="GrayText">Distance</h3>
                            </Col>
                            <Col md={{span: 16}}>
                                <h3 style={{fontWeight: "normal"}} className="GrayText">200km (5h travel time)</h3>
                            </Col>
                        </Row> */}
                            <Row>
                                <Col md={{ span: 22 }}>
                                    <h3 style={{ fontWeight: "normal" }} className="GrayText">
                                        {trip.tripDescription}
                                    </h3>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 6 }}>
                            <Card>
                                <Row>
                                    <Col md={{ span: 16 }}>
                                        {/* <img src={carImage} style={{height: '90%', width: '90%'}} alt="logo" /> */}
                                        <Image
                                            src={(trip.user && trip.user.primary_vehicle.length > 0) && (API_HOST_URL + (trip.user && trip.user.primary_vehicle[0].vehiclePhoto))}
                                            height={100}
                                            width={150}
                                        // style={style.vehicleImage}
                                        />
                                    </Col>
                                    <Col md={{ span: 8 }}>
                                        <h4 style={{ fontWeight: "bold" }} className="GrayText"> {trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].numberPlate}</h4>
                                        <h4 className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].vehicleModel}</h4>
                                        <h4 style={{ fontWeight: "normal" }} className="GrayText">{trip.user && trip.user.primary_vehicle.length > 0 && trip.user.primary_vehicle[0].color}</h4>
                                    </Col>
                                </Row>
                                <Divider />

                                <h4 style={{ fontWeight: "normal" }} className="GrayText">
                                    <Icon type="shopping" theme="filled" style={{ color: `${(trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed == 'No') ? 'red' : 'green'}` }} /> {trip.user && trip.user.primary_vehicle.length && trip.user.primary_vehicle[0].lagguageAllowed} Luggage allowed</h4>

                            </Card>
                        </Col>
                    </Row>
                </Card>
                {/* #0099ff */}
                <Row style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                    <Col md={{ span: 4, offset: 3 }} >
                        {trip.numberOfSeats > 0 &&
                            <Card bordered={false} style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                                <h3 style={{ color: "#ffffff" }}>Booked: {trip.numberOfSeatsBooked}</h3>
                            </Card>
                        }
                    </Col>
                    <Col md={{ span: 8 }} >
                        <Card bordered={false} style={{ backgroundColor: `${trip.numberOfSeats > 0 ? '#0099ff' : '#f5222d'}` }}>
                            {trip.numberOfSeats > 0 ?
                                <Button size="large" type="primary" style={{ backgroundColor: "#ff3d00", borderWidth: '0px' }}>
                                    <Link to={`book/${trip.id}`}>Book Seats Now</Link>
                                </Button>
                                :
                                <h2 style={{ color: 'white' }}>Trip fully booked</h2>
                            }
                        </Card>
                    </Col>
                    <Col md={{ span: 6 }}>
                        <Card bordered={false} style={{ backgroundColor: "#1275b5" }}>
                            <Row>
                                <Col md={{ span: 8 }}>
                                    <h3 style={{ color: "#ffffff" }}>
                                        {
                                            trip.numberOfSeats > 0 &&
                                            <div>
                                                <span style={{ fontSize: '1.5em' }}>{trip.numberOfSeats}</span>
                                                <span>{ trip.numberOfSeats > 1 ? 'seats':'seat'} left</span>
                                            </div>
                                        }
                                    </h3>
                                </Col>
                                <Col md={{ span: 16 }}>
                                    <h3 style={{ color: "#ffffff" }}>
                                        <span style={{ fontSize: '1.5em' }}>
                                            <NumberFormat value={trip.pricePerSeat} displayType={'text'} thousandSeparator={true} prefix={'Ush '} />
                                        </span>
                                        <span> <br />per seat</span>
                                    </h3>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>

                </Mobile>


            </div>
        );
    }
}


export default TripDetail;
